import { useEffect, useState } from "react";
import axios from "../../../axios";
import { Link } from "react-router-dom";

export default function BankAccountListPage() {
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        axios.get("/admin/bank-accounts").then((res) => setAccounts(res.data));
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Nonaktifkan rekening ini?")) {
            await axios.delete(`/admin/bank-accounts/${id}`);
            setAccounts(accounts.map(a => a.id === id ? { ...a, is_active: false } : a));
        }
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-0">Daftar Rekening Bank</h4>
            </div>
            <div className="card-body">
                <Link to="/admin/bank-accounts/create" className="btn btn-success mb-3">Tambah Rekening</Link>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Bank</th>
                            <th>Nama Pemilik</th>
                            <th>Nomor</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map((a) => (
                            <tr key={a.id}>
                                <td>{a.bank_name}</td>
                                <td>{a.account_name}</td>
                                <td>{a.account_number}</td>
                                <td>{a.is_active ? "Aktif" : "Nonaktif"}</td>
                                <td>
                                    <Link to={`/admin/bank-accounts/${a.id}/edit`} className="btn btn-sm btn-warning">Edit</Link>{" "}
                                    {a.is_active && (
                                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(a.id)}>Nonaktifkan</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
